export const customerRequestContants = {
    RESET: 'RESET',
    REQUEST_FETCHING: 'REQUEST_FETCHING',
    REQUEST_FETCHED: 'REQUEST_FETCHED',
    REQUEST_SUBMITTING: 'REQUEST_SUBMITTING',
    REQUEST_SUBMITTED: 'REQUEST_SUBMITTED',
    SEARCH_COMPANY: 'SEARCH_COMPANY',
    LOAD_COMPANY_REQUEST: 'LOAD_COMPANY_REQUEST',
    GET_COMPANY_REQUEST_BY_ID: 'GET_COMPANY_REQUEST_BY_ID',
}